import { cx } from '../../cx'
import { Check } from '../../icons'
import styles from './ProcessTimeline.module.css'

export interface ProcessTimelineItem {
  key: string
  label: string
  /** Właściciel fazy — „Pracownik", „Dział HR", „System" (spec 04). */
  owner?: string
}

export interface ProcessTimelineProps {
  items: readonly ProcessTimelineItem[]
  /** Numer bieżącej fazy, liczony od 1. */
  current: number
  /** Ostrzeżenie na bieżącej fazie — proces stoi (np. warunki odrzucone). */
  blocked?: boolean
  tone?: 'onDark' | 'onLight'
  className?: string
}

/**
 * Pionowy timeline procesu zatrudnienia (spec 04 — szyna boczna portalu).
 *
 * Różni się od `StepRail` tym, że niesie właściciela fazy i łączy kropki linią:
 * pracownik ma widzieć nie tylko „gdzie jest", ale i „na kogo teraz czeka".
 */
export function ProcessTimeline({
  items,
  current,
  blocked = false,
  tone = 'onDark',
  className,
}: ProcessTimelineProps) {
  return (
    <ol className={cx(styles.timeline, tone === 'onLight' && styles.onLight, className)}>
      {items.map((item, index) => {
        const number = index + 1
        const state = number < current ? 'done' : number === current ? 'active' : 'future'
        return (
          <li
            key={item.key}
            className={cx(styles.item, styles[state], state === 'active' && blocked && styles.blocked)}
            aria-current={state === 'active' ? 'step' : undefined}
          >
            <span className={styles.marker} aria-hidden="true">
              <span className={styles.dot}>
                {state === 'done' ? <Check size={12} strokeWidth={3} /> : null}
              </span>
              {index < items.length - 1 ? <span className={styles.line} /> : null}
            </span>
            <span className={styles.text}>
              <span className={styles.label}>{item.label}</span>
              {item.owner ? <span className={styles.owner}>{item.owner}</span> : null}
            </span>
          </li>
        )
      })}
    </ol>
  )
}
